/* @ngInject */
const wagonButtons = (
  utils,
  icons,
  wagonGo,
  wagonAsk,
  wagonTest,
  wagonLabels,
) => {
  const self = {}

  self.edit = {
    icon: icons.edit,
    action: wagonGo.edit,
    display: _nature => _nature !== 'tables' || utils.screenSize > 600,
  }

  self.search = {
    icon: icons.search,
    action: wagonGo.consult,
    display: _nature => _nature === 'tables',
  }

  self.delete = {
    icon: icons.delete,
    action: wagonAsk.delete,
    display: _nature => _nature !== 'tables',
    class: _wagon => 'retour',
  }

  self.badges = [{
    ref: 'badge_avarie',
    color: () => 'badge-avarie',
    label: wagonLabels.badge.damaged,
    display: _wagon => _wagon ? _wagon.damaged : false,
  }, {
    ref: 'badge_isole',
    color: () => 'badge-isole',
    label: wagonLabels.badge.isolated,
    display: _wagon => _wagon ? _wagon.isolated : false,
  }, {
    ref: 'revisionBadge',
    color: ({ revisionDate, step, extendRevision, }) => {
      return wagonTest.getRevisionColor(revisionDate, step, extendRevision)
    },
    label: wagonLabels.badge.revision,
    display: ({ revisionDate, step, extendRevision, }) => {
      return !wagonTest.isRevisionOk(revisionDate, step, extendRevision)
    },
  }, {
    ref: 'dateBadge',
    color: () => 'badge-date',
    label: wagonLabels.badge.date,
    display: _wagon => _wagon ? !wagonTest.isDateTrainOk(_wagon.arrivalDate) : false,
  }, {
    ref: 'scrappingBadge',
    color: () => 'badge-scrapping',
    label: wagonLabels.badge.scrapping,
    display: _wagon => _wagon ? _wagon.scrapped : false,
  }, {
    ref: 'announceBadge',
    color: () => 'badge-announce',
    label: wagonLabels.badge.scrapping,
    display: _wagon => _wagon ? _wagon.announceScrapping && !_wagon.scrapped : false,
  }, {
    ref: 'commentBadge',
    color: () => 'badge-comment',
    label: wagonLabels.badge.comment,
    display: _wagon => _wagon ? _wagon.comment : false,
  },]

  return self
}
export default wagonButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/resources/buttons.resource.js